import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class PermitionListen extends Component {
    static displayName = PermitionListen.name;
    state = {
        active: "false"
    };

    componentDidMount() {
        //this.getCard();
    }


    doChoice = (e) => {
        e.preventDefault();
        let choice = cardService.getChoiceCard();
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است');;
            return;
        }
        utils.sendSms(choice.deviceNumber, `call,${this.state.active == "false" ? "0" : "1"}`)
        toast.dark('لطفا تا دریافت پیام از سیستم صبر کنید');
        this.props.closeModal(e); 
    }

    render() {

        return (
            <>
                <CustomModal dd="modal-sm" show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" >
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">اجازه شنود کاربران</div>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col">
                                <span>فعال</span>
                            </div>
                            <div className="col-auto">
                                <input type="radio"
                                    name="active"
                                    value="true"
                                    checked={this.state.active == "true"}
                                    onChange={(e) => http.handleChange2(e, this)} />
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col">
                                <span>غیر فعال</span>
                            </div>
                            <div className="col-auto">
                                <input type="radio"
                                    name="active"
                                    value="false"
                                    checked={this.state.active == "false"}
                                    onChange={(e) => http.handleChange2(e, this)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                    <button className="btn btn-dark" onClick={(e) => { this.doChoice(e) }}>انتخاب</button>
                                </div>
                            </div>
                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                    <button className="btn btn-dark" onClick={(e) => this.props.closeModal(e)}>انصراف</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}